module.exports = __webpack_public_path__ + "static/media/DynamicList.cssmodule.c5bd5a3c.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DynamicList/DynamicList.cssmodule.scss
// module id = 944
// module chunks = 0